const TOKEN_KEY = "vinyl.token";
const REMEMBER_KEY = "vinyl.rememberMe";

export function loadToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function saveToken(token: string, rememberMe: boolean): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(REMEMBER_KEY, rememberMe ? "1" : "0");
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REMEMBER_KEY);
}

export function loadRememberMe(): boolean {
  return localStorage.getItem(REMEMBER_KEY) === "1";
}
